import React from "react";
import { UIToggle } from "./UIToggle";

/**
 * Переключатель (Switch) с текстовым лейблом.
 * @param {Object} props
 * @param {boolean} props.checked - Состояние переключателя (вкл/выкл)
 * @param {function} props.onChange - Обработчик изменения состояния
 * @param {string} props.labelOn - Текст при включённом состоянии
 * @param {string} props.labelOff - Текст при выключенном состоянии
 * @param {Object} props.style - Дополнительные стили для контейнера
 */
const LabeledSwitch = ({
    checked,
    onChange,
    labelOn,
    labelOff,
    style = {},
}) => {
    return (
        <div
            style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                ...style,
            }}
        >
            <UIToggle
                checked={checked}
                onChange={onChange}
            />
            <span
                onClick={onChange}
                style={{
                    fontSize: "14px",
                    fontWeight: 500,
                    color: checked ? "#1CA46B" : "#54606F",
                    userSelect: "none",
                    cursor: "pointer",
                }}
            >
                {checked ? labelOn : labelOff}
            </span>
        </div>
    );
};

export default LabeledSwitch;
